import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { Link } from 'react-router';
import {
    get_jobseeker_profile,
    // getHallTicketData
} from '../../../actions/jobseekerAction'
// import {get_jobseeker_profile} from '../../../actions/jobseekerAction'
import store from '../../../store'
import ServerSetting from '../../../config.json';
import { MDBProgress } from 'mdbreact';
// const SKILL_PROVIDER_ID = "4"
// const COUNSELLING_PROVIDER_ID = "5"
// const FORGIEN_JOB_PROVIDER_ID = "2"
// const FORGIEN_STUDY_PROVIDER_ID = "11"
import {
    deleteAccount
} from '../../../actions/counsellingproviderAction';
import { get_dogilocker_adhaar, Islogin } from '../../../actions/accountAction';


class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            basePath: window.location.protocol + '//' + window.location.host + '/',
            delIndex: '',
            isLoginData: null,
        }

        store.dispatch(Islogin())
        // store.dispatch(get_dogilocker_adhaar())

    }

    async componentDidMount() {
        window.openCloseSidebar()
        if (this.props.JobseekerReducer.Profile && !Object.keys(this.props.JobseekerReducer.Profile).length) {
            store.dispatch(get_jobseeker_profile());
        }

        try {
            const res = await store.dispatch(Islogin());
            this.setState({ isLoginData: res });
        } catch (err) {
        }
        // if (this.props.JobseekerReducer.hallTicketData && !this.props.JobseekerReducer.hallTicketData.length) {
        //     store.dispatch(getHallTicketData())
        // }
    }

    getColor = () => {
        let progress = this.props.route.path === '/myprofile' ?
            this.props.JobseekerReducer.progress :
            parseInt(localStorage.getItem('progress'))
        if (progress === 20) return 'danger'
        if (progress === 40) return 'warning'
        if (progress === 60) return 'info'
        if (progress === 80) return 'success'
        if (progress === 100) return 'success'
    }


    getVerifyLink = () => {
        store.dispatch(get_dogilocker_adhaar())
    }

    handleUserInput(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value)
        });
    }


    changeRegister = (event) => {
        window.location.href = this.state.basePath + 'signup?type=' + event;
    }

    capitalizeFirstLetter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }


    deleteRecord = () => {
        // const { delIndex } = this.state
        // if (delIndex !== "") {
        this.handleDeleteEducation()
        document.getElementById("exampleModaldelete").click()
        // }
    }

    handleDeleteEducation() {
        // store.dispatch(deleteEducation({ id: this.props.counsellingproviderReducer.educations[index].id }));
        store.dispatch(deleteAccount(this?.props?.JobseekerReducer?.Profile));

        this.setState({ delIndex: '' })
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }


    componentDidUpdate(prevProps) {
        const prevUrl = prevProps.actionReducer?.digiUrl;
        const newUrl = this.props.actionReducer?.digiUrl;

        // When URL changes and is not empty
        if (newUrl && newUrl !== prevUrl) {
            window.open(newUrl, "_blank");  // open in new tab
        }
    }

    render() {
        let Mainprops = this.props;
        const SERVER_PATH = ServerSetting[process.env.NODE_ENV].SERVER_PATH;
        // let isSkillSearch = ''
        // let isCounsellingSearch = ''
        // let isForgienSearch = ''
        // let isForgienStudySearch = ''
        // if (this.props.JobseekerReducer.Profile && this.props.JobseekerReducer.Profile.subtype_id) {
        //     const usertype = this.props.JobseekerReducer.Profile.subtype_id.split(",")
        //     // isSkillSearch = usertype.filter((user) => user === SKILL_PROVIDER_ID)[0]
        //     isCounsellingSearch = usertype.filter((user) => user === COUNSELLING_PROVIDER_ID)[0]
        //     isForgienSearch = usertype.filter((user) => user === FORGIEN_JOB_PROVIDER_ID)[0]
        //     isForgienStudySearch = usertype.filter((user) => user === FORGIEN_STUDY_PROVIDER_ID)[0]
        // }

        let colClass = Mainprops.route.path === '/jobfair' ? 'col-md-3 widget-sidebar bgEducationSidebar py-3' : 'col-md-3 widget-sidebar bgEducationSidebar py-3'

        let progress = Mainprops.route.path === '/myprofile' ?
            this.props.JobseekerReducer.progress :
            parseInt(localStorage.getItem('progress'))

        return (
            <aside className={colClass} id="left">
                <div className="list-group w-100">
                    <ul className="nav flex-column flex-nowrap ">

                        <div className="d-flex align-items-center justify-content-center w-100 pull-left pt-2 outr-profile text-center">
                            <Link to="/myaccount" className="date-clr">
                                <div className="outr-avtar">
                                    <img alt="avatar"
                                        src={this.props.JobseekerReducer.Profile.image ? `${SERVER_PATH}${this.props.JobseekerReducer.Profile.image}` : '/images/img-1.png'}
                                        className="avatar mr-2 text-center" />
                                </div>
                            </Link>


                            <div className="mb-2 font-18">
                                <Link to="/myaccount" className="date-clr">
                                    <span className="outr-profile-text">
                                        {this.props.t('login.hi', { param: 'react' }).trimEnd()}, {this.capitalizeFirstLetter(this.props.JobseekerReducer.Profile.firstname)}</span>
                                </Link> <br />

                                {/* {this.state.isLoginData === null ? (
                                    <div></div>
                                ) : this.state.isLoginData.aadhar_card_verified === "0" ? (
                                    <Link to="/verify-adhar" className="verify-adhar-link">
                                        <div className="mb-1 font-18 verify-adhar">
                                            {this.props.t('verifyAdhar.verify_adhar', { param: 'react' })}
                                            <img alt="verify-adhar" src="/images/verify-adhar.png" style={{ marginLeft: "5px" }} />
                                        </div>
                                    </Link>
                                ) : (
                                    <div className="mb-1 font-18 verified-adhar">
                                        {this.props.t('verifyAdhar.verified_adhar', { param: 'react' })}
                                        <img alt="verify-adhar" src="/images/adhar_verified.png" style={{ marginLeft: "5px" }} />
                                    </div>
                                )} */}


                                {/* {this.state.isLoginData === null ? (
                                    <div></div>
                                ) : this.state.isLoginData.aadhar_card_verified === "0" ? (
                                    <Link to="/verify-adhar" className="verify-adhar-link">
                                        <div className="mb-1 font-18 verify-adhar">
                                            {this.props.t('verifyAdhar.verify_adhar', { param: 'react' })}
                                            <img alt="verify-adhar" src="/images/verify-adhar.png" style={{ marginLeft: "5px" }} />
                                        </div>
                                    </Link>
                                ) : (
                                    <div className="mb-1 font-18 verified-adhar">
                                        {this.props.t('verifyAdhar.verified_adhar', { param: 'react' })}
                                        <img alt="verify-adhar" src="/images/adhar_verified.png" style={{ marginLeft: "5px" }} />
                                    </div>
                                )} */}

                                {/* {this.state.isLoginData === null ? (
                                    <div></div>
                                ) : this.state.isLoginData.aadhar_card_verified === "0" ? (
                                    < div className="mb-1 font-18 verify-adhar" onClick={() => this.getVerifyLink()}>
                                        {this.props.t('verifyAdhar.verify', { param: 'react' })}
                                        <img alt="verify-adhar" src="/images/verify-adhar.png" style={{ marginLeft: "5px" }} />
                                    </div>
                                ) : (
                                    <div className="mb-1 font-18 verified-adhar">
                                        {this.props.t('verifyAdhar.profile_verified', { param: 'react' })}
                                        <img alt="verify-adhar" src="/images/adhar_verified.png" style={{ marginLeft: "5px" }} />
                                    </div>
                                )} */}

                                {this.props.t('dashboard.WelcomeDashboard', { param: 'react' })}
                            </div>

                            {progress ? <div style={{ width: "80%" }}>
                                <MDBProgress className="my-2" material
                                    value={progress}
                                    height="10px"
                                    color={this.getColor()} />
                                <div className="mb-2">
                                    <span className="date-clr">
                                        {this.props.t('profileDetails.completed', { param: 'react' })} {progress} %
                                    </span></div>
                            </div> : null}
                        </div>


                        {/* Profile Details */}
                        <li data-placement="bottom"
                            title={this.props.t('sidebar.profile_detailsDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/myprofile' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/myprofile">  <img src="../images/profile-side-icon.png" alt="My profile" className="pe-1" /> <b>{this.props.t('sidebar.profile_details', { param: 'react' })}</b>
                            </Link></li>


                        {/* My job interest */}
                        <li data-placement="bottom"
                            title={this.props.t('interest.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/interest' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/interest">  <img src="../images/my-job-interest-side-icon.png" alt="My Job Interest" className="pe-1" /> <b>{this.props.t('interest.title', { param: 'react' })}</b> </Link>
                        </li>

                        {/* search more jobs */}
                        <li data-placement="bottom"
                            title={this.props.t('sidebar.search_jobsDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/jobsearch' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/jobsearch">  <img src="../images/job-search-side-icon.png" alt="Search More Jobs" className="pe-1" /> <b>{this.props.t('sidebar.moreJobs', { param: 'react' })}</b> </Link>
                        </li>

                        {/* Applied Jobs- 26August */}
                        <li
                            data-placement="bottom"
                            title={this.props.t('interest.titleDesc', { param: 'react' })}
                            className={
                                "nav-item list-group-item " +
                                (
                                    (Mainprops.route.path === "/myaccount" &&
                                        Mainprops.location?.state?.expandAppliedJobs)  // 👈 only active if expandAppliedJobs true
                                        ? "active"
                                        : ""
                                )
                            }
                        >
                            <Link
                                className="nav-link"
                                to={{
                                    pathname: "/myaccount",
                                    state: { expandAppliedJobs: true }, // pass flag only for Applied Jobs click
                                }}
                            >
                                <img
                                    src="../images/job-mela-side-icon.png"
                                    alt="Applied Jobs"
                                    className="pe-1"
                                />
                                <b>{this.props.t("sidebar.applied_jobs", { param: "react" })}</b>
                            </Link>
                        </li>

                        {/* Job mela */}
                        <li data-placement="bottom"
                            title={this.props.t('interest.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/job-mela' || Mainprops.route.path.includes("/jobfair") ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/job-mela">  <img src="../images/job-mela-side-icon.png" alt="Job Mela" className="pe-1" /> <b> {this.props.t('sidebar.job_mela_tab', { param: 'react' })} </b>   <img src={"/images/BLINK.gif"} alt={"New"} /> </Link>
                        </li>



                        {/* <li data-placement="bottom"
                                title="Artificial Intelligence and Data Science upskilling course"
                                className={"nav-item list-group-item " + (Mainprops.route.path === '/psdm-skill-program' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/psdm-skill-program"><b>Artificial Intelligence and Data Science Upskilling Course <img src={"/images/BLINK.gif"} alt={"New"}/> </b>
                                </Link></li> */}
                        {/* {this.props.actionReducer.activeJobMela && this.props.actionReducer.activeJobMela.hasOwnProperty('expire') && !this.props.actionReducer.activeJobMela.expire ?
                            <>
                                <li data-placement="bottom"
                                    title={this.props.t('sidebar.mela', { param: 'react' })}
                                    className={"nav-item list-group-item " + (Mainprops.route.path === '/jobfair' ? 'active' : '')}>
                                    <Link className="nav-link "
                                        to="/jobfair"><b>{this.props.actionReducer.activeJobMela.jobMela}</b>
                                        <img src={"/images/BLINK.gif"} alt={"New"} />
                                    </Link></li>

                                <li data-placement="bottom"
                                    title={this.props.t('hallTicket.desc', { param: 'react' })}
                                    className={"nav-item list-group-item " + (Mainprops.route.path === '/hall-ticket' ? 'active' : '')}>
                                    <Link className="nav-link"
                                        to="/hall-ticket"><b>{this.props.t('hallTicket.sidebar', { param: 'react' })}</b></Link></li>
                            </>
                            : null} */}

                        {/* <li data-placement="bottom"
                            title={this.props.t('interest.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/interest' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/interest"><b> Job Mela</b> </Link>
                        </li> */}

                        {/* {this.props.actionReducer.activeJobMela && this.props.actionReducer.activeJobMela.length > 0 ? <li
                            title={this.props.t('interest.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/jobfair' ? 'active' : '')}>
                            <a class="nav-link my-2" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                                <b> Job Mela Dropdown </b>
                            </a>
                            {this.props.actionReducer.activeJobMela.map((mela) => (
                                mela.hasOwnProperty('expire') && !mela.expire ? <div class={`collapse mb-2  active list-group-item`} id="collapseExample">
                                    <Link className="nav-link"
                                        to={`/jobfair?mela-id=${mela.id}`}><b> {mela.jobMela}</b> </Link>
                                </div> : <></>
                            ))}

                        </li> : null} */}
                        {/* <li data-placement="bottom"
                            title={this.props.t('interest.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/registration-id-card' || Mainprops.route.path.includes("/jobfair") ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/registration-id-card"><b> Registration ID Card </b>   <img src={"/images/BLINK.gif"} alt={"New"} /> </Link>
                        </li>

                        <li data-placement="bottom"
                            title={this.props.t('interest.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/job-resume' || Mainprops.route.path.includes("/jobfair") ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/job-resume"><b> Resume </b>   <img src={"/images/BLINK.gif"} alt={"New"} /> </Link>
                        </li> */}

                        {/* Hall ticket */}
                        <li data-placement="bottom"
                            title={this.props.t('hallTicket.desc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path.includes('/hall-ticket') ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/hall-ticket">  <img src="../images/hall-ticket-side-icon.png" alt="Hall Ticket" className="pe-1" /> <b>{this.props.t('hallTicket.sidebar', { param: 'react' })}</b>
                            </Link>
                        </li>

                        {/* Skill Developement */}
                        <li data-placement="bottom"
                            title={"Skill Development"}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/skill-development-courses' ? 'active' : '')}>
                            <Link className="nav-link"
                                to={"skill-development-courses"}><img src="../images/self-employment-side-icon.png" alt="Self Employment" className="pe-1" /> <b> {this.props.t('profileDetails.skill_dev', { param: 'react' })}</b> <img src={"/images/BLINK.gif"} alt={"New"} />  </Link>
                        </li>

                        {/* Employability Assessment */}
                        <li data-placement="bottom"
                            title={this.props.t('hireme.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/hireMee' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/hireMee">  <img src="../images/employblity-side-icon.png" alt="Employability Assessment" className="pe-1" /> <b>{this.props.t('hireme.title', { param: 'react' })}</b> </Link>
                        </li>

                        {/* <li data-placement="bottom"
                            title={this.props.t('sidebar.search_forgien_jobsDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/forgien-jobs' ? 'active' : '')}>
                            <Link className="nav-link".moreJobs
                                to="/forgien-jobs"><b>{this.props.t('sidebar.forJobs', { param: 'react' })}</b> </Link>
                        </li> */}

                        {/* counsellor/counselling */}
                        <li
                            title={this.props.t('sidebar.search_counsellingDesc', { param: 'react' })}
                            className={"nav-item  list-group-item " + (Mainprops.route.path === '/search-counselling-session-by-area' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/search-counselling-session-by-area">  <img src="../images/search-counslor-side-icon.png" alt="Search Counsellor" className="pe-1" /> <b>{this.props.t('counsellingProvider.searchCounsellor', { param: 'react' })}</b> </Link>
                        </li>

                        {/* <li
                            title={this.props.t('sidebar.search_counsellingDesc', { param: 'react' })}
                            className={"nav-item  list-group-item " + (Mainprops.route.path === '/search-counselling-session' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/search-counselling-session">  <img src="../images/foreign-side-icon.png" alt="Counselling / Foreign Counseling" className="pe-1" /> <b>{this.props.t('counsellingProvider.dashboadTitle', { param: 'react' })}</b> </Link>
                        </li> */}



                        {/* <li data-placement="bottom"
                            title={this.props.t('sidebar.search_careerDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/search-career' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/search-career"><b>{this.props.t('sidebar.searchCareerOpportunities', { param: 'react' })}</b> </Link>
                        </li> */}

                        {/* self employement */}
                        <li
                            title={this.props.t('sidebar.searchEmpDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/search-self-employment' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/search-self-employment">  <img src="../images/self-employment-side-icon.png" alt="Self Employment" className="pe-1" /> <b>{this.props.t('homeContent.selfEmp', { param: 'react' })}</b> </Link>
                        </li>


                        {/* <li
                            title={this.props.t('sidebar.searchEmpDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/search-pm-scheme' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/search-pm-scheme">  <img src="../images/self-employment-side-icon.png" alt="Pm Scheme" className="pe-1" /> <b>{this.props.t('pmVikasRojgar.pmRoj', { param: 'react' })}</b> </Link>
                        </li> */}

                        {/* Discussion Form */}
                        <li data-placement="bottom"
                            title="Click here for Forum"
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/forum' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/forum">  <img src="../images/dissucussion-forum-side-icon.png" alt="Discussion Forum" className="pe-1" /> <b>
                                    {this.props.t('forum.title', { param: 'react' })}</b> </Link>
                        </li>

                        {/* queries */}
                        <li data-placement="bottom"
                            title={this.props.t('crm.titleDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/crm' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/crm">  <img src="../images/queries-side-icon.png" alt="Queries" className="pe-1" /> <b>{this.props.t('crm.title', { param: 'react' })}</b> </Link>
                        </li>

                        {/* Help & Support   */}
                        <li data-placement="bottom"
                            title={"Help & Support"}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/skill-development-courses' ? 'active' : '')}>
                            <Link className="nav-link"
                                to={"help-and-support"}><img src="/images/Help&Support.png" alt="Help & Support" className="pe-1" /> <b> {this.props.t('profileDetails.help_support', { param: 'react' })}</b> </Link>
                        </li>

                        {/* Delete Account */}
                        <li data-placement="bottom"
                            title="Click here for Forum"
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/forum' ? 'active' : '')}>
                            <Link className="nav-link" to="#" onClick={(event) => { event.preventDefault(); }} data-toggle="modal" data-target="#exampleModaldelete">
                                <img src="../images/delete-side-icon.png" alt=" Delete Account" className="pe-1" /> <b>  {this.props.t('sidebar.del_acc', { param: 'react' })}</b>
                            </Link>
                        </li>

                        <div className="modal fade" id="exampleModaldelete" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ color: "black" }}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h6 className="modal-title" id="exampleModalLabel">Are you sure you want to delete your Account? This action cannot be undone.</h6>
                                        {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                        </button> */}
                                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-footer">
                                        <button aria-label='Ok' type="button" className="btn btn-primary btn-primary2" onClick={() => this.deleteRecord()}>Ok</button>
                                        <button aria-label='Cancel' type="button" className="btn btn-primary btn-primary2" data-dismiss="modal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <li data-placement="bottom"
                            title={this.props.t('homeContent.webinarDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/apply-webinar' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/apply-webinar"><b>{this.props.t('homeContent.webinar', { param: 'react' })}</b><img src={"/images/BLINK.gif"} alt={"New"} /></Link></li> */}

                        {/* {isForgienSearch && isForgienSearch === FORGIEN_JOB_PROVIDER_ID.toString() ?
                            <li data-placement="bottom"
                                title={this.props.t('sidebar.search_forgien_jobsDesc', { param: 'react' })}
                                className={"nav-item list-group-item " + (Mainprops.route.path === '/forgien-jobs' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/forgien-jobs"><b>{this.props.t('sidebar.search_forgien_jobs', { param: 'react' })}</b> </Link>
                            </li>
                            : ''}
                        {isCounsellingSearch && isCounsellingSearch === COUNSELLING_PROVIDER_ID.toString() ?
                            <li
                                title={this.props.t('sidebar.search_counsellingDesc', { param: 'react' })}
                                className={"nav-item  list-group-item " + (Mainprops.route.path === '/search-counselling-session' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/search-counselling-session"><b>{this.props.t('sidebar.search_counselling', { param: 'react' })}</b> </Link>
                            </li>

                            : ''}
                        {isForgienStudySearch && isForgienStudySearch === FORGIEN_STUDY_PROVIDER_ID.toString() ?
                            <li
                                title={this.props.t('sidebar.searchStudyDesc', { param: 'react' })}
                                className={"nav-item list-group-item " + (Mainprops.route.path === '/search-forgien-study' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/search-forgien-study"><b>{this.props.t('jobSearch.searchStudy', { param: 'react' })}</b> </Link>
                            </li> : ''} */}
                        {/* <li
                            title={this.props.t('sidebar.searchEmpDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/search-self-employment' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/search-self-employment"><b>{this.props.t('sidebar.searchEmp', { param: 'react' })}</b> </Link>
                        </li>
                        <li data-placement="bottom"
                            title={this.props.t('sidebar.search_lspDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/servicesearch' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/servicesearch"><b>{this.props.t('sidebar.search_service', { param: 'react' })}</b> </Link>
                        </li>
                        <li data-placement="bottom"
                            title={this.props.t('sidebar.search_careerDesc', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/search-career' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/search-career"><b>{this.props.t('sidebar.search_career', { param: 'react' })}</b> </Link>
                        </li>
                        <li data-placement="bottom"
                            title={this.props.t('sidebar.search_trainingDesc', { param: 'react' })}
                            className={"nav-item list-group-item"}>
                            <a className="nav-link"
                                rel="noopener noreferrer"
                                target="_blank"
                                href="http://psdm.webappline.com/"><b>{this.props.t('sidebar.search_training', { param: 'react' })}
                                </b> </a>
                        </li> */}
                        {/* <li data-placement="bottom"
                            title={this.props.t('sidebar.mela', { param: 'react' })}
                            className={"nav-item list-group-item " + (Mainprops.route.path === '/jobfair' ? 'active' : '')}>
                            <Link className="nav-link"
                                to="/jobfair"><b>{this.props.t('sidebar.job_mela', { param: 'react' })}</b>
                                  <img src={"/images/BLINK.gif"} alt={"New"} />
                            </Link></li> */}
                        {/* {this.props.JobseekerReducer.hallTicketData && this.props.JobseekerReducer.hallTicketData.length > 0 &&
                            <li data-placement="bottom"
                                title={this.props.t('hallTicket.desc', { param: 'react' })}
                                className={"nav-item list-group-item " + (Mainprops.route.path === '/hall-ticket' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/hall-ticket"><b>Vacancies Applied in 6th State Level Mega Job Fair</b></Link></li>
                        } */}

                    </ul>
                </div >
            </aside >
        );
    }
}

const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(translate(Sidebar));
